//region block: pre-declaration
//endregion
function get_DEVELOPMENT_MODE() {
  return false;
}
//region block: exports
export {
  get_DEVELOPMENT_MODE as get_DEVELOPMENT_MODE18ax9b1n971lk,
};
//endregion

//# sourceMappingURL=ByteChannel.web.mjs.map
